import { JobStatus } from "../../../api/types/jobs/JobStatus";
import { resumeJob } from "../thunks/resumeJob";
import { IActionErrorInfo } from "../types/IActionErrorInfo";
import { JobsExtraBuilder } from "./types/jobsExtraBuilder";

export const addResumeJob = (builder: JobsExtraBuilder) => {
  builder.addCase(resumeJob.pending, (state, action) => {
    state.loadingJobKeys = [...state.loadingJobKeys, action.meta.arg];
  });
  builder.addCase(resumeJob.rejected, (state, action) => {
    if (state.loadingJobKeys) {
      state.loadingJobKeys = state.loadingJobKeys.filter((id) => id !== action.meta.arg);
    }

    const error: IActionErrorInfo = {
      id: Date.now(),
      message: `Ошибка запуска задачи ID: ${action.meta.arg}!: ${action.error.message}`,
    };
    state.jobErrors = state.jobErrors ? [...state.jobErrors, error] : [error];
  });

  builder.addCase(resumeJob.fulfilled, (state, action) => {
    if (state.loadingJobKeys) {
      state.loadingJobKeys = state.loadingJobKeys.filter((id) => id !== action.meta.arg);
    }
    state.allJobs = state.allJobs.map((j) => {
      if (j.id == action.meta.arg) {
        return { ...j, status: `${JobStatus.pending}` };
      }
      return j;
    });
  });
};
